import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import axios from "axios";

// Fetch a list of sources to add to the map
const useSources = (routeType) => {
  const [sources, setSources] = useState([]);
  const { data, isError, isLoading } = useQuery(
    ["Sources", `/api/public-map/sources/${routeType}`],
    async () => {
      try {
        return await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/public-map/sources/${routeType}`
        );
      } catch (err) {
        console.error(err);
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setSources(data?.data || []);
  }, [data]);

  return { isError, isLoading, sources, setSources };
};

export default useSources;
